(() => {
  if (window.KPSet || !window.KPSetData) return;
  const cfg = window.KPSetData;
  const root = window.Shopify?.routes?.root || '/';
  const money = value => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value / 100);
  const meta = id => cfg.h[id] ? { h: String(id), l: 0, c: '0' } : cfg.packs[id];
  const giftVariants = new Set(Object.values(cfg.gifts).map(Number));
  const giftFor = id => cfg.gifts[cfg.h[meta(id)?.h]?.color];
  const accessory = id => cfg.l[id] ? { ...cfg.l[id], kind: 'l' } : cfg.c[id] ? { ...cfg.c[id], kind: 'c' } : null;
  let lastCart;
  let pending = Promise.resolve();
  const mutations = new Set();
  let checkoutPending = false;
  const trackMutation = task => {
    mutations.add(task);
    task.then(() => mutations.delete(task), () => mutations.delete(task));
    return task;
  };
  const settleCart = async () => {
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(items => items.flushQuantityChange?.());
    while (mutations.size) await Promise.all([...mutations]);
    await pending;
    await syncGift(await getCart());
  };
  const checkout = async event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    const button = event.submitter || event.target.closest?.('[name="checkout"],a[href*="/checkout"]');
    button?.setAttribute('aria-busy', 'true');
    if (button && 'disabled' in button) button.disabled = true;
    try {
      await settleCart();
      window.location.assign(root + 'checkout');
    } catch (error) {
      const box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (box) { box.setAttribute('role', 'alert'); box.textContent = 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es noch einmal.'; }
      checkoutPending = false;
      button?.removeAttribute('aria-busy');
      if (button && 'disabled' in button) button.disabled = false;
    }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[name="checkout"],a[href]');
    if (!target) return;
    const linkCheckout = target.tagName === 'A' && new URL(target.href, window.location.href).pathname.replace(/\/$/, '').endsWith('/checkout');
    if (target.name === 'checkout' || linkCheckout) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  const post = async (path, data) => {
    const response = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || result.errors || 'Bitte versuche es noch einmal.');
    return result;
  };
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
    return response.json();
  };
  const sections = () => document.querySelector('cart-drawer')?.getSectionsToRender().map(s => s.id) || ['cart-icon-bubble'];
  const attachSections = async (cart, names) => {
    const surfaces = ['main-cart-items', 'main-cart-footer'].map(id => ({ element: document.getElementById(id), selector: '.js-contents' })).filter(s => s.element?.dataset.id);
    const requested = [...new Set([...names, 'cart-icon-bubble', ...surfaces.map(s => s.element.dataset.id), ...(document.querySelector('cart-drawer') ? ['cart-drawer'] : [])])];
    if (requested.length) {
      const response = await fetch(`${root}?sections=${encodeURIComponent(requested.join(','))}`, { cache: 'no-store' });
      cart.sections = await response.json();
      const parser = new DOMParser();
      if (!names.includes('cart-icon-bubble') && cart.sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        const next = parser.parseFromString(cart.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && next) bubble.innerHTML = next.innerHTML;
      }
      if (!names.includes('cart-drawer') && cart.sections['cart-drawer']) {
        const inner = document.querySelector('cart-drawer .drawer__inner');
        const next = parser.parseFromString(cart.sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        if (inner && next) inner.innerHTML = next.innerHTML;
      }
      for (const surface of surfaces) {
        const key = surface.element.dataset.id;
        if (names.includes(key) || !cart.sections[key]) continue;
        const target = surface.element.querySelector(surface.selector);
        const next = parser.parseFromString(cart.sections[key], 'text/html').querySelector(surface.selector);
        if (target && next) target.innerHTML = next.innerHTML;
        surface.element.classList.toggle('is-empty', !cart.item_count);
      }
    }
    lastCart = cart;
    decorate();
    return cart;
  };
  const giftChanges = cart => {
    const desired = {};
    for (const item of cart.items) {
      const giftId = giftFor(item.variant_id);
      if (giftId) desired[giftId] = (desired[giftId] || 0) + item.quantity;
    }
    const gifts = cart.items.filter(item => giftVariants.has(Number(item.variant_id)));
    for (const item of gifts.filter(item => item.properties?._kp_gift !== '1')) {
      desired[item.variant_id] = Math.max(0, (desired[item.variant_id] || 0) - item.quantity);
    }
    const updates = {};
    for (const item of gifts.filter(item => item.properties?._kp_gift === '1')) {
      const quantity = desired[item.variant_id] || 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
      delete desired[item.variant_id];
    }
    const items = Object.entries(desired).filter(([, quantity]) => quantity > 0).map(([id, quantity]) => ({ id: Number(id), quantity, properties: { _kp_gift: '1' } }));
    return { updates, items };
  };
  const syncGiftNow = async (cart, names) => {
    const { updates, items } = giftChanges(cart);
    if (Object.keys(updates).length) cart = await post('cart/update.js', { updates });
    if (items.length) {
      await post('cart/add.js', { items });
      cart = await getCart();
    }
    return attachSections(cart, names);
  };
  const syncGift = (cart, names = sections()) => {
    pending = pending.catch(() => {}).then(async () => syncGiftNow(await getCart(), names));
    return pending;
  };
  const candidate = (cart, a) => cart.items.find(item => {
    const m = meta(item.variant_id);
    return m && cfg.h[m.h].color === a.color && (a.kind === 'l' ? !m.l : m.c === '0');
  });
  const upgrade = async (cart, item, a, accessoryId) => {
    const m = meta(item.variant_id);
    const id = cfg.lookup[`${m.h}|${a.kind === 'l' ? 1 : m.l}|${a.kind === 'c' ? accessoryId : m.c}`];
    if (!id) throw new Error('Diese Set-Kombination ist momentan nicht verfügbar.');
    const existing = cart.items.find(line => line.variant_id === id);
    return post('cart/update.js', { updates: { [item.key]: item.quantity - 1, [existing?.key || id]: (existing?.quantity || 0) + 1 } });
  };
  const render = cart => {
    const drawer = document.querySelector('cart-drawer');
    drawer?.classList.toggle('is-empty', !cart.item_count);
    if (drawer && cart.sections) drawer.renderContents(cart);
  };
  function decorate() {
    if (!lastCart) return;
    for (const row of document.querySelectorAll('[data-kp-upsell]')) {
      const isLeash = row.dataset.kpProduct === '15434441097469';
      const kind = isLeash ? 'l' : 'c';
      const eligible = lastCart.items.find(item => { const m = meta(item.variant_id); return m && (kind === 'l' ? !m.l : m.c === '0'); });
      const price = row.querySelector('.kp-upsell__price');
      const colorSelect = row.querySelector('select[data-kp-upsell-option]');
      if (eligible && colorSelect) {
        const color = cfg.h[meta(eligible.variant_id).h].color;
        if (colorSelect.value !== color) { colorSelect.value = color; colorSelect.dispatchEvent(new Event('change', { bubbles: true })); }
        colorSelect.disabled = true;
      } else if (colorSelect) colorSelect.disabled = false;
      const html = eligible ? `<strong>${money(isLeash ? 1395 : 995)}</strong> <s>${money(isLeash ? 2295 : 1895)}</s> <span class="kp-set-badge">Set-Preis</span>` : money(isLeash ? 2295 : 1895);
      const state = `${kind}-${eligible ? 'set' : 'single'}`;
      if (price && price.dataset.kpPriceState !== state) { price.dataset.kpPriceState = state; price.innerHTML = html; }
    }
  }
  window.KPSet = {
    trackMutation,
    settleCart,
    prepare(id, quantity, items) {
      if (!cfg.h[id]) return null;
      const l = items.find(item => cfg.l[item.id]);
      const c = items.find(item => cfg.c[item.id]);
      const pack = l || c ? cfg.lookup[`${id}|${l ? 1 : 0}|${c?.id || '0'}`] : Number(id);
      if (!pack) return { error: 'Diese Set-Kombination ist momentan nicht verfügbar. Bitte prüfe die Auswahl.' };
      const giftId = giftFor(id);
      if (!giftId) return { error: 'Das passende Geschenk ist momentan nicht verfügbar. Bitte prüfe die Auswahl.' };
      return { id: pack, extras: [{ id: giftId, quantity, properties: { _kp_gift: '1' } }] };
    },
    syncGift,
    async afterAdd(response, names) {
      const cart = await syncGift(await getCart(), names);
      return { ...response, sections: cart.sections };
    },
    async upsell(button, variant) {
      if (!variant?.available) return;
      const row = button.closest('[data-kp-upsell]');
      const error = row.querySelector('[data-kp-upsell-error]');
      button.disabled = true;
      if (error) error.hidden = true;
      let complete;
      trackMutation(new Promise(resolve => { complete = resolve; }));
      try {
        let cart = await getCart();
        const a = accessory(variant.id);
        const item = a && candidate(cart, a);
        if (item) cart = await upgrade(cart, item, a, variant.id);
        else { await post('cart/add.js', { items: [{ id: variant.id, quantity: 1 }] }); cart = await getCart(); }
        render(await syncGift(cart));
      } catch (e) {
        button.disabled = false;
        if (error) { error.textContent = e.message; error.hidden = false; }
      } finally {
        complete();
      }
    },
    getCart,
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; decorate(); });
  }).observe(document.body, { childList: true, subtree: true });
  getCart().then(async cart => {
    lastCart = cart;
    decorate();
    const changes = giftChanges(cart);
    if (changes.items.length || Object.keys(changes.updates).length) await syncGift(cart, []);
  }).catch(() => {});
})();
